import AgendaItemTitle from './AgendaItemTitle';

export default AgendaItemTitle;